import Header from './Header';
import { Clock, Mail, MapPin, Phone } from 'lucide-react';
import '../styles/Pages.css';

export default function ContatoSuporte() {
  const handleSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const nome = formData.get('nome') || '';
    const email = formData.get('email') || '';
    const assunto = formData.get('assunto') || 'Contato pelo site';
    const mensagem = formData.get('mensagem') || '';

    const subject = encodeURIComponent(assunto);
    const body = encodeURIComponent(
      `Nome: ${nome}\nEmail: ${email}\n\nMensagem:\n${mensagem}`
    );

    window.location.href = `mailto:atendimento@bcbconsultoria.com.br?subject=${subject}&body=${body}`;
  };

  return (
    <div className="page">
      <Header />
      <main className="page-content">
        <section id="contato-suporte" className="page-hero">
          <div className="page-container">
            <span className="page-eyebrow">Contato e suporte</span>
            <h1>Estamos prontos para atender sua equipe com agilidade.</h1>
            <p>
              Fale com nosso time comercial ou abra um chamado de suporte para resolver
              dúvidas técnicas, integrações e necessidades do dia a dia.
            </p>
          </div>
        </section>

        <section className="page-section">
          <div className="page-container contact-grid">
            <div className="contact-card">
              <h2>Central de atendimento</h2>
              <p>
                Nosso time está disponível em horário comercial para orientar
                sua equipe e acompanhar cada etapa da implantação.
              </p>
              <ul>
                <li>
                  <Phone size={16} />
                  Telefone: (11) 94056-0518 / (81) 3071-4527
                </li>
                <li>
                  <Mail size={16} />
                  Email: atendimento@bcbconsultoria.com.br
                </li>
                <li>
                  <MapPin size={16} />
                  Endereço: Rua Vigário Barreto, 50
                </li>
                <li>
                  <Clock size={16} />
                  Resposta média: até 24h úteis
                </li>
              </ul>
            </div>

            <div className="contact-card-form">
              <h2>Abra um chamado</h2>
              <form className="contact-form" onSubmit={handleSubmit}>
                <input type="text" name="nome" placeholder="Seu nome" />
                <input type="email" name="email" placeholder="Seu email" />
                <input type="text" name="assunto" placeholder="Assunto" />
                <textarea name="mensagem" rows="5" placeholder="Descreva sua necessidade" />
                <button type="submit">Enviar mensagem</button>
              </form>
            </div>
          </div>
        </section>
      </main>

    </div>
  );
}
